import { Autocomplete as MaterialAutocomplete } from '@material-ui/lab';
import { SearchSmallIcon } from '@images/icons';
import { translate } from '@utils';

export const Autocomplete = (props) => {
  const {
    options,
    filterOptions,
    renderOption,
    getOptionLabel,
    loading,
    renderInput,
    getOptionSelected,
    onInputChange,
    onChange,
    getOptionDisabled,
  } = props;

  return (
    <MaterialAutocomplete
      value={null}
      options={options}
      filterOptions={filterOptions}
      renderOption={renderOption}
      getOptionLabel={getOptionLabel}
      loading={loading}
      renderInput={renderInput}
      getOptionSelected={getOptionSelected}
      onInputChange={onInputChange}
      onChange={onChange}
      popupIcon={<SearchSmallIcon />}
      noOptionsText={translate('no_options')}
      getOptionDisabled={getOptionDisabled}
    />
  );
};

Autocomplete.defaultProps = {
  filterOptions: (options) => options,
  getOptionLabel: () => '',
  getOptionSelected: (option, value) => value.id,
  loading: false,
};

export default Autocomplete;
